import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from '../locales/ar.json';
import en from '../locales/en.json';

void i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: 'ar',
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
});

if (import.meta.hot) {
  import.meta.hot.accept(['../locales/ar.json', '../locales/en.json'], (mods) => {
    if (!mods) return;
    const [nextAr, nextEn] = mods;
    if (nextAr) i18n.addResourceBundle('ar', 'translation', nextAr.default, true, true);
    if (nextEn) i18n.addResourceBundle('en', 'translation', nextEn.default, true, true);
    void i18n.changeLanguage(i18n.language);
  });
}

export default i18n;
